var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContactUs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7B8989",
    d: "M17.442 4.13a8.004 8.004 0 0 1 5.37 12.069 2.406 2.406 0 0 0 .011 2.48L23.6 20h-7.632a8.116 8.116 0 0 1-5.491-2.29 10.085 10.085 0 0 0 2.162-.801A6.127 6.127 0 0 0 16.198 18l4.311-.001-.012-.083a4.42 4.42 0 0 1 .596-2.74c1.752-2.848.873-6.546-1.948-8.284a6.027 6.027 0 0 0-1.058-.517 9.856 9.856 0 0 0-.516-1.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#273941",
    d: "M1.205 12.199C-1.143 8.435.045 3.506 3.859 1.189 7.674-1.128 12.67.044 15.02 3.808a7.92 7.92 0 0 1 1.202 4.31c-.144 4.424-3.844 7.924-8.33 7.882H.405l.788-1.32c.47-.762.474-1.716.012-2.481z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactUs);
export default __webpack_public_path__ + "static/media/icon-contact-us.9b24270f.svg";
export { ForwardRef as ReactComponent };